<template>
  <div>
    <v-card class="py-5">
      <v-card-title class="pt-0 text-h5 justify-center"> No Posts </v-card-title>

      <v-card-text class="text-center"> It seems that your home feed is empty<br /> </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn to="/rate" text color="primaryText" :small="$vuetify.breakpoint.xs">Write a Review </v-btn>
        <v-spacer></v-spacer>
        <v-btn to="/search" text color="primaryText" :small="$vuetify.breakpoint.xs">Find Friends </v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="py-5 mt-5">
      <v-card-title class="pt-0 text-h5 justify-center"> Recommended </v-card-title>

      <div
        v-for="account in recommended.filter((user) => user.friendRequestStatus !== 'approved')"
        :key="account.username"
        class="px-3 d-flex py-1"
      >
        <router-link :to="{ name: 'profile', params: { username: account.username } }">
          <profile-avatar :username="account.username" :size="48" class="mr-2"></profile-avatar>
        </router-link>

        <p class="mb-0">
          <router-link :to="{ name: 'profile', params: { username: account.username } }">
            <span class="name" v-if="account.first_name || account.last_name"
              >{{ account.first_name }} {{ account.last_name }}</span
            >
            <span class="name" v-else>{{ account.username }}</span> </router-link
          ><br />
          <span class="username" v-if="account.first_name || account.last_name">@{{ account.username }}</span>
        </p>

        <v-spacer></v-spacer>
        <v-btn
          @click="
            addFriendById(account.id);
            account.friendRequestStatus = 'outgoing';
          "
          color="primary"
          class="align-self-center"
          width="100"
          :disabled="account.friendRequestStatus === 'outgoing'"
        >
          <span v-if="account.friendRequestStatus === 'outgoing'">Requested</span>
          <span v-else>Add</span>
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import Friends from "../../mixins/friends";

export default {
  name: "NoFeed",

  mixins: [Friends],

  data: function () {
    return {
      recommended: [
        {
          username: "Telemonial",
          id: 122,
          friendRequestStatus: "",
          first_name: "Telemonial",
        },
        {
          username: "TrevorMitchell",
          id: 1,
          first_name: "Trevor",
          last_name: "Mitchell",
          friendRequestStatus: null,
        },
        {
          username: "Zach Winters",
          id: 2,
          friendRequestStatus: "",
          first_name: "Zach",
          last_name: "Winters",
        },
      ],
    };
  },

  mounted() {
    this.loadFriendshipStatuses();
  },

  methods: {
    loadFriendshipStatuses: async function () {
      for (let user of this.recommended) {
        try {
          user.friendRequestStatus = await this.getFriendshipStatus(user.id);
        } catch (e) {
          console.error(e);
        }
      }
    },
  },
};
</script>

<style scoped>
p {
  line-height: 1.2;
  height: 48px;
}

.name {
  font-weight: bold;
  font-size: 20px;
  color: var(--v-text-base);
}
.name:hover {
  text-decoration: underline;
}
</style>
